<div class="content form-group" fxLayout="row wrap">
    <div fxFlex="100" class="inputs" fxLayout="row wrap">
        <app-edit-suggestion-field [isEditable]="isEditable" [label]="'Depot Name*'" [displayField]="'name'"
            [name]="'name'" [(ngModel)]="depotFormObject.name" (onSelect)="editDepotMaster($event)"
            [listUrl]="base_url+'location/?location_type_name=depot&name=::search::'" fxFlex="12em" fxLayout="column"
            class="align-items-center" [errors]="errorObj.name">
        </app-edit-suggestion-field>

        <app-mat-auto-search [isEditable]="isEditable" [label]="'Country*'" [name]="'country'"
            [(ngModel)]="depotFormObject.country" [listUrl]="country_url+'country/?name=::search::'"
            (ngModelChange)="filterStatebyCountryID($event)" fxFlex="12em" [displayField]="'name'" fxLayout="column"
            class="align-items-center" [errors]="errorObj.country" [idField]="null">
        </app-mat-auto-search>

        <app-mat-auto-search [isEditable]="isEditable" [label]="'State*'" [name]="'state'" [listUrl]="stateUrl"
            fxFlex="12em" [(ngModel)]="depotFormObject.state" (ngModelChange)="onStateChange($event)"
            [displayField]="'name'" fxLayout="column" class="align-items-center" [idField]="null"
            [disabled]="stateDisabled" [errors]="errorObj.state">
            <!-- [errors]="errorObj.state" -->
        </app-mat-auto-search>

        <app-text-field [isEditable]="isEditable" [label]="'Full Address*'" [(ngModel)]="depotFormObject.address"
            [name]="'address'" [isMultiline]="true" [minlength]="5" fxFlex="12em" fxLayout="column"
            class="align-items-center" [errors]="errorObj.address">
        </app-text-field>
        <div fxFlex="100" class="introButton" *ngIf="isSavebutton">
            <button mat-raised-button (click)="saveDepot()"> Save </button>
        </div>
    </div>

    <ng-container *ngIf="depotCreated">
        <div class="content form-group" id="card2" fxLayout="column wrap">
            <div class="headContent d-flex justify-content-between">
                <span class="head"> <b> Depot-Port Mapping*</b></span>
                <!-- <button *ngIf="isEditable" mat-stroked-button (click)="Defaultport()" class="sleekBtn">Add</button> -->
            </div>
            <mat-divider></mat-divider>

            <div>
                <span class="depot-port">{{errorObj.is_primary}} </span>
            </div>
            <div fxFlex="100" class="inputs depotInput" fxLayout="row wrap">
                <div fxFlex="100" class="p-lr-2rem" fxLayout="row wrap">
                    <div class="flip-card" *ngFor="let item of locationPorts, let i = index">
                        <div id="fci{{i}}" class="flip-card-inner">
                            <div class="flip-card-front">
                                <img id="cardBg" src="assets/images/demo/flipcard-bg1.jpg" alt="">
                                <div class="distCard">
                                    <div>
                                        <i class="flaticon-ribbon prime" [class.hidden]="!item.is_primary"></i>
                                        <i class="flaticon-pencil" (click)="edit(i)"></i>
                                    </div>
                                    <p>
                                        {{item?.port?.name_display}}
                                    </p>
                                    <div class="ikm">
                                        <label for="km"> {{item.distance_in_km}}
                                            KMs</label>
                                    </div>
                                </div>
                            </div>

                            <div class="flip-card-back">
                                <div class="distCard">
                                    <div>
                                        <mat-slide-toggle color="primary" [(ngModel)]="item.is_primary"
                                            [disabled]="!isEditable">
                                            Primary
                                        </mat-slide-toggle>
                                        <i class="flaticon-tick" (click)="onPortsSave(item,i)"></i>
                                    </div>
                                    <div class="ikm">
                                        <app-mat-auto-search [isEditable]="isEditable" [placeholder]="'Select Port'"
                                            [name]="'port'" [displayField]="'name_display'" [setSearchValue]="false"
                                            [listUrl]="base_url+'location/?location_type_name=port&search=::search::'"
                                            [(ngModel)]="item.port" fxFlex.gt-xs="19em" fxLayout="column"
                                            class="align-items-center" [errors]="item.errorObj?.port" [beLight]="true">
                                        </app-mat-auto-search>
                                        <!-- [options]="dd_ports?.results" -->
                                        <div class="ikmBox">
                                            <app-number-field [isEditable]="isEditable" [label]="'KMs'" [maxlength]="5"
                                                [(ngModel)]="item.distance_in_km" [minValue]="0"
                                                [name]="'distance_in_km'" fxFlex.gt-xs="45" fxLayout="column"
                                                [errors]="item.errorObj?.distance_in_km" [beLight]="true">
                                            </app-number-field>
                                            <span>KMs</span>
                                            <mat-checkbox color="primary" [(ngModel)]="item.is_active"
                                                [disabled]="!isEditable">Active</mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="portCreated">
        <div class="headContent d-flex justify-content-between">
            <span class="head"> <b> Contact Details*</b></span>
        </div>
        <mat-divider></mat-divider>
        <div fxFlex="100" class="inputs" fxLayout="row wrap">
            <app-text-field [isEditable]="isEditable" [label]="'First Name*'"
                [(ngModel)]="contactObject.first_name" [name]="'first_name'" [maxlength]="10" [minlength]="3"
                [errors]="errorObj.first_name" fxFlex="12em" fxLayout="column"  class="align-items-center">
            </app-text-field>


            <app-text-field [isEditable]="isEditable" [label]="'Last Name'" [(ngModel)]="contactObject.last_name"
                [name]="'last_name'" [maxlength]="10" [errors]="errorObj.last_name" fxFlex="12em" fxLayout="column"  class="align-items-center">
            </app-text-field>


            <app-phone-field [isEditable]="isEditable" [label]="'Mobile No'" [(ngModel)]="contactObject.phone"
                [name]="'phone'" [errors]="errorObj.phone" fxFlex="12em" fxLayout="column" class="align-items-center">
            </app-phone-field>


            <app-text-field [data]="" [isEditable]="isEditable" [label]="'Email ID*'" [placeholder]="''"
                [(ngModel)]="contactObject.email" [name]="'email'" [maxlength]="100" [minlength]="5" fxFlex="12em" fxLayout="column"  class="align-items-center"
                [errors]="errorObj.email">
            </app-text-field>
            <div fxFlex="100" class="introButton">
                <button mat-raised-button  (click)="postContact(contactObject)"> Save</button>
            </div>
        </div>
    </ng-container>
</div>